<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-1 h-9 text-black-white text-l-medium">
        <Icon icon="Hardware-Wireframe-Receiver" class="size-6" />
        <span class="text-l-medium text-black-white">
          {{ $t('setting.device.usbReportRate.title') }}
        </span>
      </div>
    </div>
    <div class="mt-1 flex items-center gap-2">
      <Button
        v-for="option in rateOptions"
        :key="option.value"
        color="normal"
        size="sm"
        class="w-17 h-8"
        :active="currentRate === option.value"
        @click="setRate(option.value as KeyboardPerfCfgTypes.USBReportRate)"
      >
        {{ option.label }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue'
  import { Button, Icon } from '@rapoo/element'
  import { useDeviceStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  import type { KeyboardPerfCapability, KeyboardPerfCfgTypes } from '@rapoo/device-sdk'

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const currentRate = ref<KeyboardPerfCfgTypes.USBReportRate>(0x82)

  // 从 manifest 读取回报率可选项
  const rateOptions = computed(() => {
    const perfCap = currentDevice.value?.manifest.capabilities?.find(
      (c): c is KeyboardPerfCapability => c.type === 'keyboardPerf',
    )
    return perfCap?.config.reportRateOptions ?? []
  })

  function requirePerfCfg() {
    const perf = currentDevice.value?.features?.keyboardPerfCfg
    if (!perf) throw new Error('当前设备未装配性能参数能力')
    return perf
  }

  async function setRate(rate: KeyboardPerfCfgTypes.USBReportRate) {
    await requirePerfCfg().setReportRate(rate)
    currentRate.value = rate
  }

  onMounted(async () => {
    try {
      const rate = await requirePerfCfg().getReportRate()
      if (rate !== 0) currentRate.value = rate as KeyboardPerfCfgTypes.USBReportRate
    } catch {
      // 读取失败时保持默认值
    }
  })
</script>

<style scoped></style>
